import frLocale from 'date-fns/locale/fr';

export const SIMPLE_DATE_FORMAT = 'dd/MM/yyyy';
export const DATETIME_FORMAT = 'dd/MM/yyyy hh:mm:ss';

export function getDateFnsLocale(locale) {
  return locale === 'fr' ? frLocale : null;
}

/**
 * Checks the input value and converts it to a Date object if it is a string.
 *
 * @param {Date|string|null} value - The date value to be checked and formatted.
 * @returns {Date|null} - The formatted date as a Date object or null if the input is null.
 */
export function checkAndFormatFormDate(value) {
  if (value == null) return value;
  if (typeof value === 'string') return new Date(value);
  return value;
}

/**
 * Gets the end of the day time (in milliseconds) for the given date.
 *
 * @param {Date} date - The date for which to get the end of day time.
 * @returns {number} - The end of day time in milliseconds.
 */
export function getEndOfDayTime(date) {
  const endOfDay = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);
  return endOfDay.getTime();
}

export function formatDuration(milliseconds) {
  if (!milliseconds || milliseconds <= 0) return '--';

  const seconds = Math.floor(milliseconds / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);

  if (hours > 0) {
    return `${hours}h ${minutes % 60}m`;
  } else if (minutes > 0) {
    return `${minutes}m ${seconds % 60}s`;
  } else {
    return `${seconds}s`;
  }
}

/**
 * Convert Java LocalDateTime array to JavaScript Date
 * @param {Array} dateArray - [year, month, day, hour, minute, second, nanosecond]
 * @returns {Date|null}
 */
export function parseJavaDateTime(dateArray) {
  if (!Array.isArray(dateArray) || dateArray.length < 6) {
    return null;
  }

  // Java month is 1-based, JavaScript month is 0-based
  const [year, month, day, hour, minute, second, nanosecond = 0] = dateArray;
  const millisecond = Math.floor(nanosecond / 1000000);

  return new Date(year, month - 1, day, hour, minute, second, millisecond);
}

/**
 * Get parsed date from job status or step details
 */
export function parseDate(dateValue) {
  if (!dateValue) return null;

  if (Array.isArray(dateValue)) {
    return parseJavaDateTime(dateValue);
  }

  if (typeof dateValue === 'string') {
    return new Date(dateValue);
  }

  return dateValue instanceof Date ? dateValue : null;
}
